exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-94364532],.container[data-v-94364532],.error-msg[data-v-94364532]{margin:16px}.droparea[data-v-94364532]{width:100%;height:100%}#upload[data-v-94364532]{text-align:center;height:100%}.uploading[data-v-94364532]{width:100%;text-align:center}.uploading .circle.notch[data-v-94364532]{margin-bottom:12px;height:20px;width:22px}.uploading .progress-indicator[data-v-94364532]{margin-bottom:36px}.hidden[data-v-94364532]{visibility:hidden}", ""]);

// exports
